import React from 'react';
import PaymentsPage from '../../../../components/Admin/Payments/PaymentsPage';

const AdminPayments = () => {
	return <PaymentsPage />;
};

export default AdminPayments;
